import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Typography,
  Card,
  Row,
  Col,
} from "antd";
import {
  FiEdit,
  FiUser,
  FiUserCheck,
  FiDollarSign,
  FiBookOpen,
} from "react-icons/fi";
import AdminDashLayout from "../../../Components/Admin/AdminDashLayout";
import useNavHeading from "../../../Hooks/CommonHooks/useNavHeading ";
import { useDispatch, useSelector } from "react-redux";
import { createVisitorThunk } from "../../../Store/Slices/Admin/visitorManagement/visitor.action";
import toast from "react-hot-toast";
import { fetchPayrollStaff } from "../../../Store/Slices/Finance/payroll/payroll.thunk";
import { fetchAllClassesDetails } from "../../../Store/Slices/Admin/Class/actions/classThunk";
import { useNavigate } from "react-router-dom";
import { fetchAllStaff } from "../../../Store/Slices/Admin/Users/Staff/staff.action";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;
const { Option } = Select;

const AddPreVisitor = () => {
      const { t } = useTranslation("common");
  useNavHeading(t("Visitor"), t("Add Pre Visitor"));
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.admin.visitor || {});
  const [staffs, setStaffs] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  // const category = Form.useWatch("category", form);
  useEffect(() => {
    dispatch(fetchAllClassesDetails());
  }, [dispatch, selectedClass]);
  useEffect(() => {
    dispatch(fetchPayrollStaff({})).then((action) => {
      setStaffs(action?.payload?.data || []);
    });
  }, []);
  // Category options
  const roleOptions = [
    { value: "all", label: t("All"), icon: <FiUser /> },
    { value: "admin", label: t("Admin"), icon: <FiUserCheck /> },
    { value: "staff", label: t("Staff"), icon: <FiUser /> },
    { value: "other", label: t("Other"), icon: <FiUser /> },
  ];

  const handleFormSubmit = async (values) => {
    const payload = {
      visitorName: values.visitorName,
      contact: values.contact,
      company: values.company,
      purposeOfVisit: values.purpose,
      hostEmployee: values.hostEmployee,
      category:
        values.category === "other" ? values.otherCategory : values.category,
      purposeOfVisit:
        values.purpose === "other" ? values.otherPurpose : values.purpose,

      assignedTo: selectedUsers.map((id) => ({ userId: id })),
      scheduledTime: values.dateTimeSlot
        ? values.dateTimeSlot.toISOString()
        : undefined,
      visitType: "pre-registered",
    };

    try {
      const result = await dispatch(createVisitorThunk(payload)).unwrap();
      toast.success(
        `${t("Invitation generated for")} ${result.visitor?.visitorName || t("visitor")}!`
      );
      form.resetFields();
      setSelectedUsers([]);
      setSelectedClass("");
      navigate("/visitor-management");
    } catch (error) {
      toast.error(error.message || t("Failed to generate invitation."));
      navigate("/visitor-management");
    }
  };
  const category =
    Form.useWatch("category", form) || form.getFieldValue("category");
  const purpose =
    Form.useWatch("purpose", form) || form.getFieldValue("purpose");

  return (
    <AdminDashLayout>
      <div className=" w-full flex justify-center p-10">
        <Card className=" border shadow-md rounded-xl">
          <Title
            level={3}
            className="text-xl font-semibold text-gray-800 mb-10  pb-2"
          >
            {t("Add Pre Visitor")}
          </Title>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleFormSubmit}
            className="w-full"
          >
            <Row gutter={[24, 16]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Visitor Name")}</Text>}
                  name="visitorName"
                  rules={[
                    { required: true, message: t("Please enter visitor's name") },
                    {
                      max: 50,
                      message: t("Visitor's name should be 50 characters or less"),
                    },
                  ]}
                >
                  <Input placeholder={t("Enter visitor's name")} size="large" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Contact Number / Email")}</Text>}
                  name="contact"
                  rules={[
                    { required: true, message: t("Please enter contact") },
                    { max: 40 },
                  ]}
                >
                  <Input
                    placeholder={t("Enter contact number or email")}
                    size="large"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label={<Text strong>{t("Company")}</Text>} name="company">
                  <Input placeholder={t("Enter visitor's company")} size="large" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Purpose of Visit")}</Text>}
                  name="purpose"
                  rules={[{ required: true, message: t("Please select purpose") }]}
                >
                  <Select placeholder={t("Select Purpose")} size="large">
                    <Option value="interview">{t("Interview")}</Option>
                    <Option value="meeting">{t("Meeting")}</Option>
                    <Option value="delivery">{t("Delivery")}</Option>
                    <Option value="other">{t("Other")}</Option>
                  </Select>
                </Form.Item>
              </Col>
              {purpose === "other" && (
                <Col xs={24} md={12}>
                  <Form.Item
                    label={<Text strong>{t("Other Purpose")}</Text>}
                    name="otherPurpose"
                    rules={[
                      {
                        required: true,
                        message: t("Please enter the other purpose"),
                      },
                      {
                        max: 20,
                        message: t("Purpose name cannot exceed 20 characters"),
                      },
                    ]}
                  >
                    <Input placeholder={t("Type your purpose")} size="large" />
                  </Form.Item>
                </Col>
              )}

              {/* ✅ Category Selector */}
              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Category")}</Text>}
                  name="category"
                  valuePropName="value"
                  rules={[
                    { required: true, message: t("Please select a category") },
                  ]}
                >
                  <Select placeholder={t("Select Category")} size="large">
                    {roleOptions.map((role) => (
                      <Option key={role.value} value={role.value}>
                        {role.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {category === "other" && (
                <Col xs={24} md={12}>
                  <Form.Item
                    label={<Text strong>{t("Other Category")}</Text>}
                    name="otherCategory"
                    rules={[
                      {
                        required: true,
                        message: t("Please enter the other category"),
                      },
                      {
                        max: 20,
                        message: t("Category name cannot exceed 20 characters"),
                      },
                    ]}
                  >
                    <Input placeholder={t("Type your category")} size="large" />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Host Employee")}</Text>}
                  name="hostEmployee"
                  rules={[
                    {
                      required: true,
                      message: t("Please select a host employee"),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder={t("Search for host employee")}
                    optionFilterProp="children"
                    size="large"
                  >
                    {staffs?.map((st) => (
                      <Option key={st._id} value={st._id}>
                        {st?.firstName} {st?.lastName} | {st?.employeeID} |{" "}
                        {st?.role}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={<Text strong>{t("Date & Time Slot")}</Text>}
                  name="dateTimeSlot"
                  rules={[
                    { required: true, message: t("Please select date & time") },
                  ]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder={t("Select date and time")}
                    size="large"
                    className="w-full"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item className="mb-0 flex justify-end mt-6">
              <button
                disabled={loading}
                type="submit"
                className="btn-gradient
                !py-3 !px-10 
                text-white font-semibold tracking-wide shadow-md transition-all duration-300"
              >
                {loading ? t("Loading...") : t("Generate Invitation")}
              </button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </AdminDashLayout>
  );
};

export default AddPreVisitor;
